import LeaveStatusSelect from './LeaveStatusSelect';

export default LeaveStatusSelect;
